export default __webpack_public_path__ + "static/merrilyDeranged-dc7c23618897f4699537566edfa34b51.svg";